/**
 * Convert the string to an HTML document
 */
function stringToHTML(source: string): HTMLElement {
  const parser = new DOMParser();
  const doc = parser.parseFromString(source, 'text/html');
  return doc.body || document.createElement('body');
}

/**
 * Remove <script> elements
 */
function removeScripts(html: HTMLElement) {
  const scripts = html.querySelectorAll('script');
  for (const script of scripts) {
    script.remove();
  }
}

/**
 * Check if the attribute is potentially dangerous
 */
function isPossiblyDangerous(name: string, value: string): boolean {
  const val = value.replace(/\s+/g, '').toLowerCase();
  if (['src', 'href', 'xlink:href'].includes(name)) {
    if (val.includes('javascript:') || val.includes('data:text/html')) return true;
  }
  if (name.startsWith('on')) return true;

  return false;
}

/**
 * Remove potentially dangerous attributes from an element
 */
function removeAttributes(elem: HTMLElement) {
  // Loop through each attribute
  // If it's dangerous, remove it
  const atts = Array.from(elem.attributes);
  for (const { name, value } of atts) {
    if (!isPossiblyDangerous(name, value)) continue;
    elem.removeAttribute(name);
  }
}

/**
 * Remove dangerous stuff from the HTML document's nodes
 */
function clean(html: HTMLElement) {
  const nodes = html.children;
  for (const node of nodes) {
    removeAttributes(node as HTMLElement);
    clean(node as HTMLElement);
  }
}

export function sanitizeHtml(source: string): string {
  const html = stringToHTML(source);

  removeScripts(html);
  clean(html);

  return html.innerHTML;
}
